import { FC, useEffect } from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import AppLayout from '../../components/layout/app-layout/app-layout';
import appState from '../../state/AppStateContainer';
import { ServiceSupplier } from '../../services/service-supplier';
import { PrequalificationDecision } from '../../util/appEnum';
import TableTopActions from '../app-supplier-database/supplier-database-top-actions';
import { EventTab } from './EventTab';
import { MonitoredSupplierTab } from './MonitoredSupplierTab';

type Params = {
  supplier?: {
    organizationNumber: string,
    name: string,
  },
  project?: {
    id: string,
    name: string,
  },
  tab?: number,
};

type RouteTypes = RouteComponentProps<null, Record<string, unknown>, Params>;

type Props = {
  history: RouteTypes['history'];
  location: RouteTypes['location'];
}

export const PageSupplierMonitoring: FC<Props> = ({ location, history }) => {
  const [t] = useTranslation('supplierDatabase');
  const registerUrl = `${appState._getCurrentOrgUrl()}/supplier-database`;

  useEffect(() => {
    const appFetchesCountAtStartUp = appState.isAdminRole() && appState.isPurchasingActive();
    if (appFetchesCountAtStartUp || appState.getSupplierApplicationCount() !== undefined) return;
    ServiceSupplier.fetchSupplier({ mini: true, prequalification: PrequalificationDecision.INBOX })
      .then(({ inboxCount }: { inboxCount: number }) => appState.setSupplierApplicationCount(inboxCount))
      .catch(error => Sentry.captureException(error));
  }, []);

  const tabs = (monitoringView: 'suppliers' | 'events') => (
    <TableTopActions
      monitoringView={monitoringView}
      onTabChange={(tab: number) => history.push(registerUrl, { tab })}
      onSelectMonitoring={(subPath: string) => history.push(`${registerUrl}${subPath}`)}
      inboxCount={appState.getSupplierApplicationCount()}
      isReadOnlyUser={appState.isReadOnlyAccessRole()}
    />
  );

  return (
    <AppLayout title={t('pageTitle', 'Leverantörer')}>
      <div className="column-content supplier-table-wrapper">
        <Switch>
          <Route exact path={`${registerUrl}/monitoring`} render={() => <MonitoredSupplierTab tabs={tabs('suppliers')} />} />
          <Route exact path={`${registerUrl}/monitoring/events`} render={() => <EventTab tabs={tabs('events')} location={location} history={history} />} />
        </Switch>
      </div>
    </AppLayout>
  );
};

export const LegacySupplierMonitoringRedirect: FC<RouteComponentProps> = ({ location }) => (
  <Redirect to={{ pathname: location.pathname.replace(/\/supplier-monitoring/i, '/supplier-database/monitoring'), state: location.state }} />
);
